import { createEvent } from "../entities/eventEntity"

function EventAdapter(eventData) {
  console.log("EventAdapter, eventData:", eventData);
    return createEvent({
      bteId: eventData.bteId,
      exchangeId: eventData.exchangeId,
      name: eventData.name,
      date: eventData.date,
      primaryEventUrl: eventData.primaryEventUrl,
      performers: eventData.performers || [],
      venue: eventData.venue,
      eventLimitNumberOfTickets: eventData.eventLimitNumberOfTickets,
      eventLimit1PurchasePerBuyer: eventData.eventLimit1PurchasePerBuyer,
      runLimit1PurchasePerBuyer: eventData.runLimit1PurchasePerBuyer,
      runLimitNumberOfTickets: eventData.runLimitNumberOfTickets,
      useRunLevelLimit: eventData.useRunLevelLimit,
      runId: eventData.runId,
      runEventIds: eventData.runEventIds,
      salesDates: eventData.salesDates || [],
      entityLink: eventData.entityLink
    });
  }
  
  export { EventAdapter };
  